export default __webpack_public_path__ + "static/media/events-icon.f9874425.png";